
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function PartnerTerms() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      <Navbar />

      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
            <h1 className="text-4xl font-bold text-gray-800 mb-8">Partner Terms & Conditions</h1>
            
            <div className="text-gray-600 space-y-8">
              <div>
                <p className="text-sm text-gray-500 mb-4">Last updated: January 2024</p>
                <p className="text-lg mb-4">
                  Welcome to the Baainearme (BNM) Partner Program. These Terms and Conditions govern your participation as a service partner on our platform.
                </p>
              </div>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Partner Relationship</h2>
                <div className="space-y-4">
                  <p>As a BNM partner, you understand that:</p>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>You are an independent contractor, not an employee of BNM</li>
                    <li>You maintain full control over your work schedule and service delivery</li>
                    <li>BNM provides a technology platform to connect you with customers</li>
                    <li>You are responsible for the quality and completion of your services</li>
                    <li>This agreement does not create an exclusive relationship</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Partner Requirements</h2>
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-gray-800">Eligibility</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Must be at least 18 years old</li>
                    <li>Have relevant skills and experience in chosen service categories</li>
                    <li>Provide valid identification and address proof</li>
                    <li>Pass background verification and reference checks</li>
                    <li>Maintain active bank account for payment processing</li>
                  </ul>

                  <h3 className="text-lg font-semibold text-gray-800">Documentation</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Aadhaar card and PAN card verification</li>
                    <li>Bank account details and cancelled cheque</li>
                    <li>Professional certifications (if applicable)</li>
                    <li>Character references from previous employers or clients</li>
                    <li>Recent photographs for profile creation</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Service Standards</h2>
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-gray-800">Quality Requirements</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Maintain professional appearance and behavior</li>
                    <li>Arrive punctually for scheduled appointments</li>
                    <li>Use appropriate tools and materials for each service</li>
                    <li>Complete services according to customer specifications</li>
                    <li>Maintain cleanliness and respect customer property</li>
                  </ul>

                  <h3 className="text-lg font-semibold text-gray-800">Communication</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Respond promptly to service requests and messages</li>
                    <li>Communicate clearly with customers about service details</li>
                    <li>Report any issues or delays immediately</li>
                    <li>Maintain respectful and professional communication</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Booking and Service Execution</h2>
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-gray-800">Service Requests</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>You have the right to accept or decline service requests</li>
                    <li>Accepted bookings must be completed as scheduled</li>
                    <li>Cancellations must be made at least 2 hours in advance</li>
                    <li>Repeated cancellations may result in account restrictions</li>
                  </ul>

                  <h3 className="text-lg font-semibold text-gray-800">Service Delivery</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Arrive within the scheduled time window</li>
                    <li>Verify customer identity and service requirements</li>
                    <li>Complete services to customer satisfaction</li>
                    <li>Request customer approval before additional charges</li>
                    <li>Update service status through the partner app</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Earnings and Payments</h2>
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-gray-800">Commission Structure</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Zero commission for your first 10 completed orders</li>
                    <li>Standard commission rates apply thereafter (varies by service type)</li>
                    <li>Bonus payments for high ratings and performance</li>
                    <li>Peak hour and weekend premium rates available</li>
                  </ul>

                  <h3 className="text-lg font-semibold text-gray-800">Payment Schedule</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Weekly payments processed every Monday</li>
                    <li>Direct bank transfer to your registered account</li>
                    <li>Detailed earning statements provided via partner app</li>
                    <li>Tax documentation provided annually</li>
                    <li>Payment disputes resolved within 48 hours</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Rating and Performance</h2>
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-gray-800">Rating System</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Customers rate services on a 1-5 star scale</li>
                    <li>Maintain minimum 4.0 average rating for continued partnership</li>
                    <li>Regular performance reviews and feedback sessions</li>
                    <li>Training provided for skill improvement</li>
                  </ul>

                  <h3 className="text-lg font-semibold text-gray-800">Performance Metrics</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Service completion rate (minimum 90%)</li>
                    <li>Customer satisfaction scores</li>
                    <li>Punctuality and reliability metrics</li>
                    <li>Response time to service requests</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Insurance and Liability</h2>
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-gray-800">Insurance Coverage</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Basic liability insurance provided by BNM during active services</li>
                    <li>Coverage for accidental property damage up to specified limits</li>
                    <li>Personal accident insurance during service hours</li>
                    <li>Partners encouraged to maintain additional insurance coverage</li>
                  </ul>

                  <h3 className="text-lg font-semibold text-gray-800">Partner Responsibilities</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Exercise reasonable care while providing services</li>
                    <li>Report incidents or damages immediately</li>
                    <li>Comply with safety protocols and guidelines</li>
                    <li>Maintain professional liability for service quality</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Prohibited Activities</h2>
                <p className="mb-4">As a partner, you agree not to:</p>
                <ul className="list-disc list-inside space-y-2 text-gray-600">
                  <li>Engage in any illegal or unethical business practices</li>
                  <li>Solicit customers for direct bookings outside the platform</li>
                  <li>Share or misuse customer personal information</li>
                  <li>Discriminate against customers based on any protected characteristics</li>
                  <li>Use BNM branding or materials for personal business</li>
                  <li>Compete directly with BNM using platform-acquired knowledge</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Account Suspension and Termination</h2>
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-gray-800">Grounds for Action</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Consistently poor performance or ratings</li>
                    <li>Violation of service standards or conduct policies</li>
                    <li>Fraudulent activities or misrepresentation</li>
                    <li>Customer safety concerns or complaints</li>
                    <li>Failure to maintain required documentation</li>
                  </ul>

                  <h3 className="text-lg font-semibold text-gray-800">Process</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Written warning for minor violations</li>
                    <li>Temporary suspension for serious issues</li>
                    <li>Opportunity to appeal and improve performance</li>
                    <li>Permanent termination for severe violations</li>
                    <li>Final payment processing within 30 days of termination</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Training and Support</h2>
                <div className="space-y-4">
                  <p>BNM provides ongoing support through:</p>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Initial onboarding and app training sessions</li>
                    <li>Regular skill development workshops</li>
                    <li>24/7 partner support helpline</li>
                    <li>Performance feedback and improvement guidance</li>
                    <li>Safety training and best practices</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Dispute Resolution</h2>
                <div className="space-y-4">
                  <p>For any disputes or concerns:</p>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    <li>Contact partner support team immediately</li>
                    <li>Provide detailed information and evidence</li>
                    <li>Participate in mediation process in good faith</li>
                    <li>Escalation to management for complex issues</li>
                    <li>Final resolution through arbitration if necessary</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Contact Information</h2>
                <p className="mb-4">For partner support and inquiries:</p>
                <div className="bg-purple-50 rounded-lg p-6">
                  <div className="space-y-2">
                    <p><strong>Email:</strong> partners@baainearme.com</p>
                    <p><strong>Phone:</strong> 93074 19845</p>
                    <p><strong>Address:</strong> BNM Headquarters, Nagpur, Maharashtra, India</p>
                    <p><strong>Support Hours:</strong> Monday-Saturday, 9 AM - 6 PM</p>
                    <p><strong>Emergency Support:</strong> Available 24/7 for urgent issues</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Agreement Updates</h2>
                <p>
                  These terms may be updated periodically to reflect changes in our operations or legal requirements. Partners will be notified of significant changes at least 30 days in advance via email or through the partner app. Continued participation in the platform constitutes acceptance of updated terms.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              {/* BNM logo (SVG) — scalable, color via currentColor */}
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 420 160"
  className="h-10 text-white"   // change to text-purple-600 etc.
  role="img"
  aria-label="BNM · Baainearme"
>
  <g fill="none" stroke="currentColor" strokeWidth="12" strokeLinecap="round">
    {/* Left ring */}
    <circle cx="50" cy="60" r="40" />
    {/* Vertical divider */}
    <line x1="110" y1="20" x2="110" y2="120" />
  </g>

  {/* Text block */}
  <g fill="currentColor">
    {/* BNM */}
    <text
      x="140"
      y="72"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="800"
      fontSize="56"
    >
      BNM
    </text>

    {/* Baainearme */}
    <text
      x="140"
      y="120"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="700"
      fontSize="32"
    >
      Baainearme
    </text>
  </g>
</svg>

              <p className="text-gray-400">
                Empowering service providers with flexible earning opportunities
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">For Partners</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/partner" className="hover:text-white cursor-pointer">Partner Home</Link></li>
                <li><Link to="/partner-privacy" className="hover:text-white cursor-pointer">Privacy Policy</Link></li>
                <li><Link to="/partner-terms" className="hover:text-white cursor-pointer">Terms & Conditions</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/customer" className="hover:text-white cursor-pointer">For Customers</Link></li>
                <li><Link to="/about" className="hover:text-white cursor-pointer">About Us</Link></li>
                <li><Link to="/refund-policy" className="hover:text-white cursor-pointer">Refund Policy</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Support</h3>
              <ul className="space-y-2 text-gray-400">
                <li>📞 93074 19845</li>
                <li>✉ support@baainearme.com</li>
                <li><a href="#" className="hover:text-white cursor-pointer">Partner Support</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Baainearme. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
